import React, { useContext } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"

import { ThemeContext, ActionButton, ActionButtonAlt, LinkButtonAlt } from "Components"

import { CenterSection } from "Styles"
import { theme } from "Theme"

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-width: ${({ image }) => (image ? theme.layout.base : "auto")};
  min-height: ${({ big }) => (big ? "400px" : "100px")};
  align-items: center;
  margin: 0 auto;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
    margin: 0 auto 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .gatsby-image-wrapper {
    position: initial !important;
  }
`

const Content = styled.div`
  display: block;
  padding: 4rem 1rem;
  margin: 0 auto;
  text-align: center;
  width: 100%;

  color: ${({ mode }) => (mode === "dark" ? theme.colors.white.base : theme.colors.background.dark)};
  background-color: ${({ mode }) => (mode === "dark" ? theme.colors.background.dark : "transparent")};
  border-color: ${({ mode }) => (mode === "light" ? "transparent" : theme.colors.background.dark)};

  @media (min-width: ${theme.breakpoints.s}) {
    padding: 4rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const FooterCTA = ({
  track,
  dark,
  big,

  image,

  title,
  subtitle,
  cta_url1_text,
  cta_url1,

  cta_url2_text,
  cta_url2,
  cta_action1,
  cta_action1_text,
  cta_action2,
  cta_action2_text,

  children,
}) => {
  const { mode } = useContext(ThemeContext)
  return (
    <>
      <Wrapper image={image} mode={dark ? "dark" : mode} big={big}>
        <Content mode={dark ? "dark" : mode}>
          {title && title !== "null" && (
            <CenterSection.Title className={!subtitle ? "mb-0" : ""}>{title}</CenterSection.Title>
          )}
          {subtitle && subtitle !== "null" && (
            <CenterSection.Subtitle className={!children ? "mb-0" : ""}>{subtitle}</CenterSection.Subtitle>
          )}
          {children && children}

          {(cta_action1_text || cta_action2_text || cta_url1_text || cta_url2_text) && (
            <div style={{ marginTop: "1rem" }}>
              {cta_action1 && cta_action1_text && cta_action1_text !== "null" && (
                <ActionButton onClick={cta_action1} track={track} title={`${title} | ${cta_action1_text}`}>
                  {cta_action1_text}
                </ActionButton>
              )}
              {cta_action2 && cta_action2_text && cta_action2_text !== "null" && (
                <ActionButtonAlt onClick={cta_action2} track={track} title={`${title} | ${cta_action2_text}`}>
                  {cta_action2_text}
                </ActionButtonAlt>
              )}
              {cta_url1 && cta_url1_text && cta_url1_text !== "null" && (
                <LinkButtonAlt to={cta_url1} track={track} title={`${title} | ${cta_url1_text}`}>
                  {cta_url1_text}
                </LinkButtonAlt>
              )}
              {cta_url2 && cta_url2_text && cta_url2_text !== "null" && (
                <LinkButtonAlt to={cta_url2} track={track} title={`${title} | ${cta_url2_text}`}>
                  {cta_url2_text}
                </LinkButtonAlt>
              )}
            </div>
          )}
        </Content>
      </Wrapper>
      {image && (
        <Wrapper dark={dark ? 1 : undefined} big={true} image={image}>
          <GatsbyImage alt={""} title={title} image={image || {} || [] || ""} />
        </Wrapper>
      )}
    </>
  )
}

export default FooterCTA
